import { Suspense, lazy } from "react";
import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import { LinearProgress } from "@mui/material";
import routes from "./routes";
// const TestCode = lazy(()=>import ("./components/TestCode"));

const navigation = lazy(() =>
  import("./components/DashboradDesign/DashboardTabs")
);
const LoginPage = lazy(() => import("./essentials/LoginPage"));
const Payment = lazy(() => import("./components/PaymentDesignFile/Payment"));
const ProjectLayout = lazy(() => import("./essentials/ProjectLayout"));
const ProjectLayout1 = lazy(() => import("./essentials/ProjectLayout1"));
const LicenseCard = lazy(() => import("./components/PaymentDesignFile/LicenseCard"));
const PaymentMethodTable = lazy(() => import("./components/PaymentDesignFile/PaymentMethodTable")); 
const Trial = lazy(() => import("./components/PaymentDesignFile/PaymentMethodTable"));
const DashBoard = lazy(() => import("./essentials/Dashboard"));
function App() {
  return (
    <div className="App">
      <Suspense fallback={<LinearProgress />}>
      <Routes>
      <Route path="/*" element={<ProjectLayout />} />
      
        <Route path="/loginPage" name="login Page" Component={LoginPage} />
        <Route path="/trail" name="trail" Component={Trial} />
        {/* <Route path="/" element={<Navigate to="/dashboard" />} /> */}
        <Route
          path="licenseCheck"
          name="license Check"
          Component={LicenseCard}
        />
        <Route path="/paymentMethod" name="paymentMethod" Component={PaymentMethodTable}/>
        <Route path="payment" name="No Response" Component={Payment} />
        {/* <Route
    path="/testCode"
    name="testCode"
    component={TestCode}
  /> */}


      </Routes>
      </Suspense>
    </div>
  );
}

export default App;
